import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import SettingsIcon from "@material-ui/icons/Settings";
import moment from "moment";
import { push } from "connected-react-router";
import Logo from "../../assets/logo.png";
import FloatMenuDesktop from "../menu/floatMenuDesktop";
import ProfileMenu from "../profile-menu/profile-menu";
import styles from "./styles.less";
import { DesktopDevice, MobileDevice } from "../hooks/responsive";
import { MobileHomeAppBar } from "./MobileHomeAppBar";
import { MobileAppBar } from "./MobileAppBar";
import ExirioStyles from "../../utils/exirioStyles";

function NavBar({ item }) {
  const dispatch = useDispatch();

  const onHome = () => {
    dispatch(push("/publicInstrument"));
  };

  const onRegisterNowClick = () => {
    dispatch({ type: "GOTO_CONFIRM_GUEST_HOLDINGS_DELETE", payload: true });
  };

  return (
    <AppBar position="fixed" className={styles.appBar}>
      <Toolbar className={styles.toolbar}>
        <MobileDevice>
          {item.homepage ? (
            <MobileHomeAppBar onHome={onHome} />
          ) : (
            <MobileAppBar route={item} onHome={onHome} />
          )}
        </MobileDevice>
        <DesktopDevice>
          <div className={styles.headActionWrapper}>
            <div className={styles.logoWrapper}>
              <img
                onClick={onHome}
                alt="logo"
                className={styles.logo}
                src={Logo}
              />
              <Typography
                variant="h4"
                color="primary"
                className={styles.navLogo}
              >
                EXIRIO
              </Typography>
            </div>
            <div className={styles.headActionWrapper}>
              <FloatMenuDesktop />
              <Typography
                variant="subtitle2"
                style={{ color: "#BDBDBD", marginLeft: 10 }}
              >
                {moment().format("dddd, DD MMM YYYY")}
              </Typography>
            </div>
          </div>
          <div className={styles.headActionWrapper}>
            {/* <Tooltip title="Documentation" enterTouchDelay={-300}>
								<IconButton
									target="_blank"
									href="https://support.exirio.com/"
								>
									<MenuBookIcon />
								</IconButton>
							</Tooltip>
							<Tooltip title="Help & Feedback" enterTouchDelay={-300}>
								<IconButton
									target="_blank"
									href="mailto:support@exirio.com?subject= Help & Feedback"
								>
									<MailOutlineIcon />
								</IconButton>
							</Tooltip>
							<Tooltip title="Settings" enterTouchDelay={-300}>
								<IconButton onClick={() => dispatch(push("/OwnerSettings"))}>
									<SettingsIcon />
								</IconButton>
							</Tooltip> */}
            <ProfileMenu />
          </div>
        </DesktopDevice>
      </Toolbar>
    </AppBar>
  );
}

export default NavBar;
